<template>
  <DpplSkeletonLoader
    class="doughnut-skeleton"
    :animate="animate"
  >
    <div class="skeleton-body">
      <div class="doughnut-container">
        <div class="outer-circle">
          <div class="inner-circle" />
        </div>
      </div>
      <DoughnutSkeletonLegend :legend-items="legendItems" />
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import DoughnutSkeletonLegend from '@/components/insights/skeletonLoaders/chartSkeletons/DoughnutSkeletonLegend.vue';

export default {
  name: 'HorizontalBarChartWidgetSkeleton',
  components: {
    DpplSkeletonLoader,
    DoughnutSkeletonLegend,
  },
  props: {
    animate: { type: Boolean, default: true },
    legendItems: { type: Array, default: () => [] },
  },
};
</script>

<style lang="less" scoped>
.doughnut-skeleton {
  height: 100%;
  width: 100%;
}

.skeleton-body {
  height: calc(100% - 17px);
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.doughnut-container {
  width: 100%;
  max-height: 260px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 30px;
}

.outer-circle {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: @grey-400;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.inner-circle {
  width: 125px;
  height: 125px;
  border-radius: 50%;
  background-color: @white;
  position: absolute;
  left: 62.5px;
  top: 62.5px;
}
</style>
